import instance from "@/services/api";

export const residentialSettingsAPI = {
  async getDocuments(project_id) {
    return await instance()
      .get(`/project/agreement/project_id/${project_id}/`)
      .then((res) => res?.data);
  },
  async signDocument(body = {}, params = {}) {
    return await instance()
      .post(`/project/agreement/sign/`, body, { params })
      .then((res) => res?.data);
  },
  async downloadDocumentPDF(body = {}) {
    return await instance()
      .post(`/project/agreement/sign/download/`, body)
      .then((res) => res?.data);
  },
  async getResidentials() {
    return await instance()
      .get("/project/resident/read/")
      .then((res) => res?.data);
  },
  async getProjectTypes(params) {
    return await instance()
      .get("/project/project_types/read/", { params })
      .then((res) => res?.data);
  },
  async getEntrances(params) {
    return await instance()
      .get(`/project/entrances/read/`, { params })
      .then((res) => res?.data);
  },
  async getIsShowAllTab(params) {
    return await instance()
      .get(`/project/is_show_all_tab/`, { params })
      .then((res) => res?.data);
  },
  async getSessionProjectAssigns(project_id) {
    return await instance()
      .get(
        `/project_list/project/read_assign_session/project_id/${project_id}/`
      )
      .then((res) => res?.data);
  },
  async getEntranceApartments(params) {
    return await instance()
      .get(`/project/flats/read/`, { params })
      .then((res) => res?.data);
  },
  async getFloorMapHeaderInfo(floor_map_id) {
    return await instance()
      .get(`/project/floor_map/${floor_map_id}/header/`)
      .then((res) => res?.data);
  },
  async getEntranceWorkSets(params) {
    return await instance()
      .get(`/project/work_sets/read/`, { params })
      .then((res) => res?.data);
  },
  async getFloorTabs(params = {}) {
    return await instance()
      .get("/project/common/tabulation/read/", { params })
      .then((res) => res?.data);
  },
  async sendDocumentAvrTo1C(floor_map_document_id, params = {}) {
    return await instance()
      .post(
        `/project/documents/${floor_map_document_id}/avr/send/`,
        {},
        { params }
      )
      .then((res) => res?.data);
  },
  async getFloorProjectInfo(project_id) {
    return await instance()
      .get(`/project/${project_id}/info/`)
      .then((res) => res?.data);
  },
  async sendAgreementTo1C(project_id, body) {
    return await instance()
      .post(`/project/${project_id}/agreement/send/`, body)
      .then((res) => res?.data);
  },
  async getIsProjectSBS(project_id) {
    return await instance()
      .get(`/project/${project_id}/is_sbs/`)
      .then((res) => res?.data);
  },
  async getFloorSchema(floor_map_id, params = {}) {
    return await instance()
      .get(`/project/floor_map/${floor_map_id}/info/`, { params })
      .then((res) => res?.data);
  },
  async getFloorMaterials(floor_map_id, params = {}) {
    return await instance()
      .get(`/project/floor_map/${floor_map_id}/materials/read/`, { params })
      .then((res) => res?.data);
  },
  async getObjectInfo(params = {}) {
    return await instance()
      .get("/floor_map/floor_params/details/read/", { params })
      .then((res) => res?.data);
  },
  async getFloorParamTypes() {
    return await instance()
      .get("/floor_map/floor_params/param_types/all/read/")
      .then((res) => res?.data);
  },
  async updateFloorParam(body = {}, params = {}) {
    return await instance()
      .put("/floor_map/floor_params/update/", body, { params })
      .then((res) => res?.data);
  },
  async getFloorWorkSets(floor_map_id, params = {}) {
    return await instance()
      .get(`/project/floor_map/${floor_map_id}/work_set/read/`, { params })
      .then((res) => res?.data);
  },
  async getExecListScreedPlacementRows(floor_map_id, params = {}) {
    return await instance()
      .get(
        `/project/floor_map/${floor_map_id}/work_set/exec_list/placement_rows/read/`,
        { params },
      )
      .then((res) => res?.data);
  },
  async getFloorWorkSetsManager(floor_map_id, params = {}) {
    return await instance()
      .get(`/project/floor_map/${floor_map_id}/work_set/manager/read/`, {
        params,
      })
      .then((res) => res?.data);
  },
  async getFloorWorkSetBreakdown(floor_map_id, params = {}) {
    return await instance()
      .get(`/project/floor_map/${floor_map_id}/work_set/breakdown/read/`, {
        params,
      })
      .then((res) => res?.data);
  },
  async getFloorWorkSetParams(floor_map_id, work_set_id, params = {}) {
    return await instance()
      .get(
        `/project/floor_map/${floor_map_id}/work_set/${work_set_id}/floor_param/read/`,
        {
          params,
        }
      )
      .then((res) => res?.data);
  },
  async completeWorkSet(floor_map_id, body = {}) {
    return await instance()
      .post(`/project/floor_map/${floor_map_id}/work_set/complete/`, body)
      .then((res) => res?.data);
  },
  async callOKK(floor_map_id, body = {}) {
    return await instance()
      .post(`/project/floor_map/${floor_map_id}/work_set/call/`, body)
      .then((res) => res?.data);
  },
  async validateExecListBeforeOkk(floor_map_id, params = {}) {
    return await instance()
      .get(
        `/project/floor_map/${floor_map_id}/work_set/exec_list/validate_before_okk/`,
        { params }
      )
      .then((res) => res?.data);
  },
  async createExecListDocument(floor_map_id, body = {}, params = {}) {
    return await instance()
      .post(
        `/project/floor_map/${floor_map_id}/work_set/exec_list/create/`,
        body,
        { params }
      )
      .then((res) => res?.data);
  },
  async reformExecListDocument(floor_map_id, body = {}, params = {}) {
    return await instance()
      .post(
        `/project/floor_map/${floor_map_id}/work_set/exec_list/reform/`,
        body,
        { params }
      )
      .then((res) => res?.data);
  },
  async createExecListManual(floor_map_id, body = {}, params = {}) {
    return await instance()
      .post(
        `/project/floor_map/${floor_map_id}/work_set/exec_list/create_manual/`,
        body,
        { params }
      )
      .then((res) => res?.data);
  },
  async getCheckedCallsForExecList(params = {}) {
    return await instance()
      .get(`/project/documents/calls_checked_exec_list/read/`, { params })
      .then((res) => res?.data);
  },
  async deleteOKKCall(body = {}) {
    return await instance()
      .delete(`/project/floor_map/okk_call/delete/`, {
        data: body,
      })
      .then((res) => res?.data);
  },
  async checkCertificates(body = {}) {
    return await instance()
      .post(`/project/floor_map/check_sertificates/`, body)
      .then((res) => res?.data);
  },
  async validateCall(params = {}) {
    return await instance()
      .get(`/project/floor_map/call/validate/`, { params })
      .then((res) => res?.data);
  },
  async getAcceptanceProcessStatus(params = {}) {
    return await instance()
      .get(`/project/floor_map/acceptance/process_status/read/`, { params })
      .then((res) => res?.data);
  },
  async getFloorMapAcceptanceCode(floor_map_id) {
    return await instance()
      .get(
        `/project/floor_map/${floor_map_id}/acceptance_code/read/`,
      )
      .then((res) => res?.data);
  },
  async getPreNuCallInfo(body = {}) {
    return await instance()
      .post(`/project/floor_map/pre_nu_call_info/`, body)
      .then((res) => res?.data);
  },
  async createAsrPreCall(body = {}, params = {}) {
    return await instance()
      .post(`/project/floor_map/create_asr_pre_call/`, body, { params })
      .then((res) => res?.data);
  },
  async getLastAsrPreCall(floor_map_id, params = {}) {
    return await instance()
      .get(
        `/project/floor_map/${floor_map_id}/work_set/asr_pre_call/last/`,
        { params },
      )
      .then((res) => res?.data);
  },
  async getCheckedCallsForAsr(params = {}) {
    return await instance()
      .get(`/project/documents/calls_checked_asr/read/`, { params })
      .then((res) => res?.data);
  },
  async getLastAsrForContractor(params = {}) {
    return await instance()
      .get(`/project/documents/asr_manual/last/`, { params })
      .then((res) => res?.data);
  },
  async getAsrDocInfo(params = {}) {
    return await instance()
      .get(`/project/documents/asr_manual/info/`, { params })
      .then((res) => res?.data);
  },
  async createAsrManual(body = {}, params = {}) {
    return await instance()
      .post(`/project/documents/asr_manual/create/`, body, { params })
      .then((res) => res?.data);
  },
  async reformAsrManual(body = {}, params = {}) {
    return await instance()
      .post(`/project/documents/asr_manual/reform/`, body, { params })
      .then((res) => res?.data);
  },
  async getEntranceMaterials(params) {
    return await instance()
      .get(`/project/materials/read/`, { params })
      .then((res) => res?.data);
  },
  async createEntranceMaterialRequest(body, params) {
    return await instance()
      .post(`/project/provider_requests/create/`, body, { params })
      .then((res) => res?.data);
  },
  async getContractorAgreementsByMaterial(params) {
    return await instance()
      .get(`/project/provider_requests/agreements/`, { params })
      .then((res) => res?.data);
  },
  async getContractorAgreementsBySbsProject(params) {
    return await instance()
      .get(`/project/provider_requests/agreements-by-project/`, { params })
      .then((res) => res?.data);
  },
  async getMaterialsByAgreement(params) {
    return await instance()
      .get(`/project/provider_requests/materials-by-agreement/`, { params })
      .then((res) => res?.data);
  },
  async getMaterialPriceByAgreement(params) {
    return await instance()
      .get(`/project/provider_requests/material-price-by-agreement/`, { params })
      .then((res) => res?.data);
  },
  async getEntranceMaterialRequests(params) {
    return await instance()
      .get(`/project/provider_requests/read/`, { params })
      .then((res) => res?.data);
  },
  async updateProviderRequestItemQty(body, params) {
    return await instance()
      .post(`/project/provider_requests/item/qty/update/`, body, { params })
      .then((res) => res?.data);
  },
  async getProviderRequestInvoices(provider_request_id) {
    return await instance()
      .get(`/project/provider_requests/${provider_request_id}/invoices/`)
      .then((res) => res?.data);
  },
  async getRealizes(params) {
    return await instance()
      .get(`/project/realizes/read/`, { params })
      .then((res) => res?.data);
  },
  async getRealizeItems(params) {
    return await instance()
      .get(`/project/realizes/items/read/`, { params })
      .then((res) => res?.data);
  },
  async getRealizeItems(params) {
    return await instance()
      .get(`/project/realizes/items/read/`, { params })
      .then((res) => res?.data);
  },
  async deleteEntranceMaterialRequest(params = {}) {
    return await instance()
      .delete(`/project/provider_requests/delete/`, { params })
      .then((res) => res?.data);
  },
  async sendInvoiceTo1C(provider_request_invoice_id, targetSystem = null) {
    const body = targetSystem ? { target_system: targetSystem } : {};
    return await instance()
      .post(
        `/provider_request/invoice/${provider_request_invoice_id}/send_to_1c/`,
        body
      )
      .then((res) => res?.data);
  },
  async signInvoice(provider_request_invoice_id, signerType) {
    return await instance()
      .post(`/provider_request/invoice/${provider_request_invoice_id}/sign/`, {
        signer_type: signerType,
      })
      .then((res) => res?.data);
  },
  async downloadInvoice(provider_request_invoice_id) {
    const response = await instance().get(
      `/provider_request/invoice/${provider_request_invoice_id}/download/`,
      { responseType: "blob" }
    );
    return response;
  },
  async downloadRealize(realize_id) {
    const response = await instance().get(
      `/project/realizes/${realize_id}/download/`,
      { responseType: "blob" }
    );
    return response;
  },
  async signRealize(realize_id) {
    return await instance()
      .post(`/project/realizes/${realize_id}/sign/`)
      .then((res) => res?.data);
  },
  async sendRealizeTo1C(realize_id) {
    return await instance()
      .post(`/project/realizes/${realize_id}/send_to_1c/`)
      .then((res) => res?.data);
  },
  async getEntrancePayments(params) {
    return await instance()
      .get(`/project/payments/read/`, { params })
      .then((res) => res?.data);
  },
  async getPlanFactPaymentReport(params) {
    return await instance()
      .get(`/project/reports/plan-fact-payment/read/`, { params })
      .then((res) => res?.data);
  },
  async getOperFactBkCompareReport(params) {
    return await instance()
      .get(`/project/reports/oper-fact-bk-compare/read/`, { params })
      .then((res) => res?.data);
  },
  async exportOperFactBkCompareReport(params) {
    return await instance()
      .get(`/project/reports/oper-fact-bk-compare/export/`, { params, responseType: 'blob' })
      .then((res) => res?.data);
  },
  async getSbsInagroKonstruktivByResident(params) {
    return await instance()
      .get('/preset/preset_material/sbs_inagro_konstruktiv_by_resident/read/', { params })
      .then((res) => res?.data);
  },
  async getResourceStatementReport(params) {
    return await instance()
      .get(`/project/reports/resource-statement/read/`, { params })
      .then((res) => res?.data);
  },
  async exportResourceStatementReport(params) {
    return await instance()
      .get(`/project/reports/resource-statement/export/`, { params, responseType: 'blob' })
      .then((res) => res?.data);
  },
  async getResourceRemainderReport(params) {
    return await instance()
      .get(`/project/reports/resource-remainder/read/`, { params })
      .then((res) => res?.data);
  },
  async exportResourceRemainderReport(params) {
    return await instance()
      .get(`/project/reports/resource-remainder/export/`, { params, responseType: 'blob' })
      .then((res) => res?.data);
  },
  async getResourceStatementFloors(params) {
    return await instance()
      .get(`/project/reports/resource-statement/floors/read/`, { params })
      .then((res) => res?.data);
  },
  async getResourceStatementProjectTypes(params) {
    return await instance()
      .get(`/project/reports/resource-statement/project-types/read/`, { params })
      .then((res) => res?.data);
  },
  async getResourceStatementResidents() {
    return await instance()
      .get(`/project/reports/resource-statement/residents/read/`)
      .then((res) => res?.data);
  },
  async getResourceStatementEntrances(params) {
    return await instance()
      .get(`/project/reports/resource-statement/entrances/read/`, { params })
      .then((res) => res?.data);
  },
  async getResourceStatementFloorsByResident(params) {
    return await instance()
      .get(`/project/reports/resource-statement/floors-by-resident/read/`, { params })
      .then((res) => res?.data);
  },
  async getPriceVarianceReport(params) {
    return await instance()
      .get(`/project/reports/price-variance/read/`, { params })
      .then((res) => res?.data);
  },
  async exportPriceVarianceReport(params) {
    return await instance()
      .get(`/project/reports/price-variance/export/`, { params, responseType: 'blob' })
      .then((res) => res?.data);
  },
  async getPriceVarianceFilters() {
    return await instance()
      .get(`/project/reports/price-variance/filters/read/`)
      .then((res) => res?.data);
  },
  /** Справочник контрагентов (поиск по имени на клиенте). */
  async getContractorsList() {
    return await instance()
      .get(`/project_list/contractors/read/`)
      .then((res) => res?.data);
  },
  async getEntranceStages(params) {
    return await instance()
      .get(`/project/stages/read/`, { params })
      .then((res) => res?.data);
  },
  async getEntranceDocumentFloors(params) {
    return await instance()
      .get(`/project/documents/floors/read/`, { params })
      .then((res) => res?.data);
  },
  async getEntranceDocumentTypes() {
    return await instance()
      .get(`/project/common/document_types/read/`)
      .then((res) => res?.data);
  },
  async getPlacementTypes() {
    return await instance()
      .get(`/project/common/placement_types/read/`)
      .then((res) => res?.data);
  },
  async getEntranceDocuments(params, signal) {
    return await instance()
      .get(`/project/documents/read/`, { params, signal })
      .then((res) => res?.data);
  },
  async getDocumentAsrCertificates(params) {
    return await instance()
      .get(`/project/documents/asr/certificates/read/`, { params })
      .then((res) => res?.data);
  },
  async getEntranceDocumentsPreCallPto(params) {
    return await instance()
      .get(`/project/documents/pre_call/pto/read/`, { params })
      .then((res) => res?.data);
  },
  async getEngineerPtoAssignmentsRead() {
    return await instance()
      .get(`/project/documents/pre_call/pto/session/assignments/read/`)
      .then((res) => res?.data);
  },
  async getPtoDocumentsSessionRead(params) {
    return await instance()
      .get(`/project/documents/pre_call/pto/session/read/`, { params })
      .then((res) => res?.data);
  },
  async acceptPtoDocumentsSession(body) {
    return await instance()
      .post(`/project/documents/pre_call/pto/session/accept/`, body)
      .then((res) => res?.data);
  },
  async changeDateEntranceDocument(body, params) {
    return await instance()
      .put(`/project/documents/change_date/`, body, { params })
      .then((res) => res?.data);
  },
  async signEntranceDocument(body, params) {
    return await instance()
      .post(`/project/documents/sign/`, body, { params })
      .then((res) => res?.data);
  },
  async signM19OverDocument(body, params) {
    return await instance()
      .post(`/project/documents/sign/m19_over/`, body, { params })
      .then((res) => res?.data);
  },
  async getFloorMapPoints(floor_map_id, params = {}) {
    return await instance()
      .get(`/project/floor_map/${floor_map_id}/check_points/read/`, { params })
      .then((res) => res?.data);
  },
  async getFloorMapPointInfo(floor_map_id, call_check_list_point_id) {
    return await instance()
      .get(
        `/project/floor_map/${floor_map_id}/check_points/${call_check_list_point_id}/info/`
      )
      .then((res) => res?.data);
  },
  async getFloorMapChecks(floor_map_id, params = {}) {
    return await instance()
      .get(`/project/floor_map/${floor_map_id}/checks/read/`, { params })
      .then((res) => res?.data);
  },
  async getFloorOpenspace(floor_map_id) {
    return await instance()
      .get(`/project/floor_map/${floor_map_id}/openspace/read/`)
      .then((res) => res?.data);
  },
  async getSkladOptions(params) {
    return await instance()
      .get(`/material/material_sklad/read/`, { params })
      .then((res) => res?.data);
  },
  async getPurchaseTypes() {
    return await instance()
      .get(`/provider_request/purchase_types/read/`)
      .then((res) => res?.data);
  },
  async getInitiatorTypes() {
    return await instance()
      .get(`/provider_request/initiator_types/read/`)
      .then((res) => res?.data);
  },
  async updateFloorMapLine(body, params = {}) {
    return await instance()
      .put(`/project_list/floor_params/update/`, body, { params })
      .then((res) => res?.data);
  },
  async deleteFloorMapLine(floor_param_id, params = {}) {
    return await instance()
      .delete(`/project_list/floor_params/${floor_param_id}/delete/`, {
        params,
      })
      .then((res) => res?.data);
  },
  async getProjectMaterialCertificates(params = {}) {
    return await instance()
      .get(`/project/prep_materials/certificates/read/`, { params })
      .then((res) => res?.data);
  },
  async modifyProjectMaterialCertificate(formData, params = {}) {
    return await instance()
      .post(`/project/prep_materials/certificates/modify/`, formData, {
        params,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => res?.data);
  },
  async deleteProjectMaterialCertificate(params = {}) {
    return await instance()
      .delete(`/project/prep_materials/certificates/delete/`, { params })
      .then((res) => res?.data);
  },
  async getProjectLaboratoryActs(params = {}) {
    return await instance()
      .get(`/project/prep_materials/laboratory_acts/read/`, { params })
      .then((res) => res?.data);
  },
  async createProjectLaboratoryAct(formData, params = {}) {
    return await instance()
      .post(`/project/prep_materials/laboratory_acts/create/`, formData, {
        params,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => res?.data);
  },
  async updateProjectLaboratoryAct(formData, params = {}) {
    return await instance()
      .post(`/project/prep_materials/laboratory_acts/update/`, formData, {
        params,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => res?.data);
  },
  async deleteProjectLaboratoryAct(params = {}) {
    return await instance()
      .delete(`/project/prep_materials/laboratory_acts/delete/`, { params })
      .then((res) => res?.data);
  },
  async getProjectReconciliation(body = {}) {
    return await instance()
      .post(`/project/reconciliations/read/`, body)
      .then((res) => res?.data);
  },
  async batchCreateDocuments(body = {}) {
    return await instance()
      .post(`/project/documents/batch/create/`, body)
      .then((res) => res?.data);
  },
  async getManualAvrCalls(project_id) {
    return await instance()
      .get(`/project/documents/calls/manual/read/`, { params: { project_id } })
      .then((res) => res?.data);
  },
  async getManualAvrMaterials(help_call_ids) {
    return await instance()
      .post(`/project/documents/materials/manual/read/`, { help_call_ids })
      .then((res) => res?.data);
  },
  async createManualAvr(help_call_ids) {
    return await instance()
      .post(`/project/documents/manual/create/`, { help_call_ids })
      .then((res) => res?.data);
  },
  async createFollowupFromK2sv(floor_map_document_id) {
    return await instance()
      .post(`/project/documents/manual/create_followup_from_k2sv/`, { floor_map_document_id })
      .then((res) => res?.data);
  },
  /** Бумажный скан BUH_AVR: multipart file + sign_date + floor_map_document_id */
  async uploadBuhAvrManualSign({ floor_map_document_id, file, sign_date, params = {} }) {
    const form = new FormData();
    form.append("file", file);
    form.append("floor_map_document_id", String(floor_map_document_id));
    form.append("sign_date", sign_date);
    return await instance()
      .post(`/project/documents/manual/sign-upload/`, form, {
        params,
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res?.data);
  },
  async getManualDocumentTypes() {
    return await instance()
      .get(`/project/documents/manual/document_types/file/preview/read/`)
      .then((res) => res?.data);
  },
  async downloadManualPreview(help_call_ids, doc_status_code) {
    return await instance()
      .post(`/project/documents/manual/file/preview/`, { help_call_ids, doc_status_code }, {
        responseType: 'blob',
      })
      .then((res) => res);
  },
  async getM19OverWbs(resident_id, project_type_id, sbs_sklad_id) {
    const params = { resident_id, project_type_id };
    if (sbs_sklad_id != null && sbs_sklad_id !== "") {
      params.sbs_sklad_id = sbs_sklad_id;
    }
    return await instance()
      .get(`/project/documents/m19over/wbs/read/`, { params })
      .then((res) => res?.data);
  },
  async getM19OverSkladOptions(project_id) {
    const params = { project_id };
    return await instance()
      .get(`/project/documents/m19over/sklad-options/read/`, { params })
      .then((res) => res?.data);
  },
  async previewM19OverWarehouseBalances(project_id, material_ids, sbs_sklad_id) {
    return await instance()
      .post(`/project/documents/m19over/warehouse-balances/preview/`, {
        project_id,
        material_ids,
        sbs_sklad_id,
      })
      .then((res) => res?.data);
  },
  async createM19Over(project_id, materials, sbs_sklad_id) {
    return await instance()
      .post(`/project/documents/m19over/create/`, { project_id, materials, sbs_sklad_id })
      .then((res) => res?.data);
  },
  async deleteM19Over(material_overuse_id) {
    return await instance()
      .post(`/project/documents/m19over/delete/`, { material_overuse_id })
      .then((res) => res?.data);
  },
  async previewM19Over(project_id, materials) {
    return await instance(true, null, { showToast: false, throwError: true })
      .post(`/project/documents/m19over/preview/`, { project_id, materials }, {
        responseType: "blob",
        _skipErrorToast: true,
      })
      .then((res) => res);
  },
  async getMaterialOveruseReport(project_id) {
    return await instance()
      .post(`/project/documents/material-overuse/report/`, { project_id }, {
        responseType: 'blob',
        _skipErrorToast: true,
      })
      .then((res) => res);
  },
};
